import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
	content: React.ReactNode;
}

const RequestDemoLinkBlock: React.FC<Props> = ({ content }) => {
	return <div className="blue-dark-border request-demo-block" style={{ borderLeft: 'none', borderRight: 'none' }}>
		<div className="blue-dark-block skew-block white-text">
			<div>
				{content}
			</div>
		</div>
		<div className="skew-block blue-dark-border">
			<Link className="request-demo-btn" to="/contact-us?demo=true">
				Request<br /> a Demo
			</Link>
		</div>
	</div>;
};

export default RequestDemoLinkBlock;
